import { Link } from 'react-router-dom';
import { socialIcons, communicationIcons } from '@/lib/icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: socialIcons.Facebook, href: '#' },
    { name: 'Twitter', icon: socialIcons.Twitter, href: '#' },
    { name: 'LinkedIn', icon: socialIcons.Linkedin, href: '#' },
    { name: 'Instagram', icon: socialIcons.Instagram, href: '#' },
    { name: 'Email', icon: communicationIcons.Mail, href: 'mailto:contact@growthlens.com' },
  ];

  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="max-w-6xl mx-auto px-6 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4 text-center md:text-center">
            <h3 className="text-lg font-semibold text-foreground">Growth Lens</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Assess where your business stands. Know where to move next.
            </p>
            <p className="text-xs text-muted-foreground">
              Developed by SciMarq
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4 text-center md:text-center">
            <h4 className="text-sm font-medium text-foreground">Quick Links</h4>
            <nav className="flex flex-col space-y-2 items-center md:items-center">
              {footerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm"
                  aria-label={`Navigate to ${link.name}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Social Media */}
          <div className="space-y-4 text-center md:text-center">
            <h4 className="text-sm font-medium text-foreground">Connect With Us</h4>
            <div className="flex space-x-4 justify-center md:justify-center">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="text-muted-foreground hover:text-primary transition-colors duration-200 focus-visible:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-sm p-1"
                  aria-label={`Follow us on ${social.name}`}
                  target={social.href.startsWith('http') ? '_blank' : undefined}
                  rel={social.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <p className="text-xs text-muted-foreground">
              © {currentYear} GrowthLens by SciMarq. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground">
              Marketing & Sales Self Audit Tool
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;